import React from 'react';
import { Datagrid, ShowButton, TextField, DateField } from 'react-admin';
import { TList } from '../../components/wrapper';
import { LinkField } from '../../components/fields';

const ApprovableAdminActionList = props => (
	<TList {...props}>
		<Datagrid>
			<ShowButton />
			<TextField source="id" />
			<DateField source="creationDateTime" showTime />
			<DateField source="finalizeDateTime" showTime />
			<TextField source="status" />
			<LinkField source="initiator" />
			<LinkField source="finalizer" />
		</Datagrid>
	</TList>
);

export default ApprovableAdminActionList;
